import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl } from '@constants'
import { prepareHeaders, transformResponse } from '@src/reduxjs'

const statsApi = createApi({
  reducerPath: 'statsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Stats'],
  endpoints: (builder) => ({
    getBuckets: builder.query({
      query: (data) => {
        const params = {}

        if (data.from) {
          params.from = data.from
        }

        if (data.to) {
          params.to = data.to
        }

        return { url: 'stats/buckets', params }
      },
      transformResponse,
    }),
    getAlbums: builder.query({
      query: (data) => {
        const params = {}

        if (data.from) {
          params.from = data.from
        }

        if (data.to) {
          params.to = data.to
        }

        return { url: 'stats/albums', params }
      },
      transformResponse,
    }),
  }),
})

export const { useGetBucketsQuery, useGetAlbumsQuery } = statsApi

export default statsApi
